export default class EmployeeBenefitFilteredDashboard {
    tsdNo: number;
    akaName: string;
    year: number;

    health?: number;
    dental?: number;
    vision?: number;
    life?: number;
    disability?: number;
    vacation?: number;
    personal?: number;
    holiday?: number;
    _401k?: number;
    fica?: number;
    wc?: number;
    ins?: number;
    pto?: number;
    exPto?: number;
    ben?: number;
    payBen?: number;
    salary?: number;

    defined: string;
    active: string;
}


// WEBPACK FOOTER //
// ./src/models/personnel/EmployeeBenefitFilteredDashboard.ts